import { BillingChargeSubtype } from "@redotech/redo-billing-common/unified-billing/enums";
import { BalanceTypes } from "@redotech/redo-model/balance/balances";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const addBalanceCredit = {
  name: "addBalanceCredit" as const,
  input: z.object({
    amount: z
      .number()
      .refine((val) => !Number.isNaN(val), {
        message: "Amount must be a number",
      }),
    account: createEnum(BalanceTypes),
    teamId: z.string(),
    chargeSubtype: createEnum(BillingChargeSubtype, {
      enumName: "BillingChargeSubtype",
    }),
    description: z.string(),
  }),
  output: z.object({ balance: z.string() }),
};
